import * as React from 'react';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { RedirectViewController } from './RedirectViewController';
import { Spinner } from '@estee/elc-spinner';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { classes } from '~utils/Classes';

const StyledSpinner = styled(Spinner)`
    min-height: 20em;
`;

@observer
export class Redirect extends React.Component {
    private redirectViewController: RedirectViewController;

    constructor(props: Record<string, unknown>) {
        super(props);
        this.redirectViewController = diContainer.get(serviceNames.redirectViewController);
    }

    public async componentDidMount() {
        this.redirectViewController.loaded();
    }

    public render() {
        const spinnerClassName = classes('iam-spinner');

        return <StyledSpinner isLoading className={spinnerClassName} />;
    }
}
